<script>
    import { onMount, createEventDispatcher } from 'svelte';    
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
    import ByteSize from 'byte-size';
    import moment from 'moment';
    let shown =false;
    const toggle = () => (shown = !shown);
    let softwareVersion;
   
    export async function show(versionToView) {
        softwareVersion = versionToView;
        shown = true;
        console.log(softwareVersion);
    }    
   </script>
   
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           View Package Version
       </ModalHeader>
       <ModalBody>
            {#if (softwareVersion.versionNumber != null)}
                <p>Name: {softwareVersion.versionNumber}</p>
            {:else}
                <p>Name: Unknown Version</p>
            {/if}
           <p>Size: {ByteSize(softwareVersion.size, { units: 'iec' })}</p>           
           <p>Status: {softwareVersion.status == null ? 'Building':softwareVersion.status}</p>
           {#if softwareVersion.status == "Failed"}
                {#if softwareVersion.errorCode !=null}
                    <p>Build Errors: {softwareVersion.errorCode}</p>
                {:else}
                    <p>Build Errors: Not Found</p>
                {/if}
           {/if}
           <p>Version Type: {softwareVersion.installer ? 'Installer':'Data Files'}</p>
           <p>Installer Arguments: {softwareVersion.installerArgs != null ? softwareVersion.installerArgs : 'N/A'}</p>
           <p>Pre-Install Commands: {softwareVersion.preInstall == null ? 'N/A' : softwareVersion.preInstall}</p>
           <p>Post-Install Commands: {softwareVersion.postInstall == null ? 'N/A' : softwareVersion.postInstall}</p>
           <p>Cachable: {softwareVersion.cachable ? 'Yes':'No'}</p>
           <p>Created: {moment(softwareVersion.created).format('MMMM Do YYYY, HH:mm:ss')}</p>
           <p>Detination Path: {softwareVersion.destination == null ? 'N/A' : softwareVersion.destination}</p>
           <p>Forces a restart: {softwareVersion.forceRestart ? 'Yes':'No'}</p>
           <p>Restart timer: {softwareVersion.restartCountTime} seconds</p>
           <p>Custom restart message: {softwareVersion.restartMessage}</p>
           {#if (softwareVersion.primaryFile)}
		        <p>Version Primary File: {softwareVersion.primaryFile}</p>
		   {/if}
       </ModalBody>
       <ModalFooter>     
       </ModalFooter>
   </Modal>